/* eslint-disable webflow/no-delete */

import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const hasDataHoverFalse =
    data.attr &&
    data.attr.hasOwnProperty('data-hover') &&
    (data.attr['data-hover'] === 'false' || data.attr['data-hover'] === false);
  const hasXattrDataHover =
    data.xattr &&
    data.xattr.length > 0 &&
    data.xattr.some((val: Record<string, any>) =>
      val.hasOwnProperty('data-hover')
    );
  const isDropdownWrapper =
    data.hasOwnProperty('dropdown') && data.dropdown.type === 'wrapper';

  // If the node has `data-hover` but it's not a DropdownWrapper. This was caused by an incident and we want to remove this data.
  const needsMigration =
    hasDataHoverFalse && !isDropdownWrapper && !hasXattrDataHover;

  return {
    needed: needsMigration,
    logData: {
      msg: 'Remove unwanted data-hover properties',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.attr && delete data.attr['data-hover'];
      // The preceding data.attr checks are for Flow, it was already checked in the needsMigration check
      if (data.attr && Object.keys(data.attr).length === 0) {
        delete data.attr;
      }
    },
  };
};
